module.exports = __webpack_public_path__ + "img/circle-arrow-up-right.c8b42357.svg";